import { render, staticRenderFns } from "./editbuilding.vue?vue&type=template&id=dbef4510&scoped=true"
import script from "./editbuilding.vue?vue&type=script&lang=js"
export * from "./editbuilding.vue?vue&type=script&lang=js"
import style0 from "./editbuilding.vue?vue&type=style&index=0&id=dbef4510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbef4510",
  null
  
)

export default component.exports